import { useTranslation } from 'react-i18next';
import TableEmptyRow from 'components/others/TableEmptyRow';
import WorkersTableRow from './WorkersTableRow';
import type { WorkerFormRow } from '../model';

interface WorkersTableBodyProps {
    rows: WorkerFormRow[];
    readOnly: boolean;
    rate: number;
    incomeAmount: number;
    onAmountChange: (index: number, amount: number, amountRate: number) => void;
}

const WorkersTableBody = ({
    rows,
    readOnly,
    rate,
    incomeAmount,
    onAmountChange,
}: WorkersTableBodyProps) => {
    const { t } = useTranslation(['Objects']);

    if (!rows.length) {
        return (
            <tbody>
                <TableEmptyRow colSpan={4} className="text-center text-muted py-4">
                    {t('expendTeamWorkers.empty')}
                </TableEmptyRow>
            </tbody>
        );
    }

    return (
        <tbody>
            {rows.map((row, index) => (
                <WorkersTableRow
                    key={row.key}
                    row={row}
                    index={index}
                    readOnly={readOnly}
                    rate={rate}
                    incomeAmount={incomeAmount}
                    onAmountChange={onAmountChange}
                />
            ))}
        </tbody>
    );
};

export default WorkersTableBody;
